import { AxiosInstance } from 'axios';
import { Entity } from '../../interfaces/Entity';
import { XdmContextUpsertDto } from '../../models/XdmContextUpsertDto';
import { FilterFieldsDto } from '../../models';

export const deleteEntity = async (
  axios: AxiosInstance,
  entityName: string,
  entityData: Entity
): Promise<any> => {
  return axios.delete<Entity>(
    `Entity/${entityName}?partitionKey=${entityData.partitionKey}&id=${entityData.id}`
  );
};

export const addEntity = async (
  axios: AxiosInstance,
  entityName: string,
  entityData: Entity
): Promise<any> => {
  return axios.post<Entity>(`Entity/${entityName}`, entityData);
};

export const editEntity = async (
  axios: AxiosInstance,
  entityName: string,
  entityData: Entity
): Promise<any> => {
  return axios.put<Entity>(`Entity/${entityName}`, entityData);
};

export const updateXdmContextItem = async (
  axios: AxiosInstance,
  xdmContextUpsertDto: XdmContextUpsertDto
) => {
  await axios.put(
    `entity/${xdmContextUpsertDto.entityName}/context`,
    xdmContextUpsertDto
  );
};

export const createXdmContextItem = async (
  axios: AxiosInstance,
  xdmContextUpsertDto: XdmContextUpsertDto
) => {
  await axios.post(
    `entity/${xdmContextUpsertDto.entityName}/context`,
    xdmContextUpsertDto
  );
};

export const deleteXdmContextItem = async (
  axios: AxiosInstance,
  entityName: string,
  partitionKey: string,
  itemId: string,
  propertyName: string,
  xdmContextId: string
) => {
  await axios.delete(
    `entity/${entityName}/context?partitionKey=${partitionKey}&itemId=${itemId}&propertyName=${propertyName}&xdmContextId=${xdmContextId}`
  );
};

export const getEntityFieldValuesByFieldName = async (
  axios: AxiosInstance,
  entityName: string,
  fieldName: string
): Promise<string[]> => {
  const { data } =
    (await axios.get<string[]>(
      `Entity/${entityName}/filter-values?fieldName=${fieldName}`
    )) ?? [];
  return data;
};

export const getByFilter = async (
  axios: AxiosInstance,
  url: string,
  filterDto: FilterFieldsDto
): Promise<any> => {
  const { data } = await axios.post<Entity>(url, filterDto);
  return data;
};
